import { MapPin, Phone, Mail, Clock, Instagram } from 'lucide-react';
import { LOGO_WITH_NAME, WHATSAPP_URL, INSTAGRAM_URL } from '../constants';

const navLinks = [
{ label: 'Sobre', href: '#sobre' },
{ label: 'Hiperidrose', href: '#hiperidrose' },
{ label: 'Procedimento', href: '#procedimento' },
{ label: 'Depoimentos', href: '#depoimentos' },
{ label: 'Convênios', href: '#convenios' },
{ label: 'FAQ', href: '#faq' }];


export default function Footer() {
  return (
    <footer className="bg-[#0a1628] text-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-14 w-14 rounded-xl overflow-hidden bg-black flex-shrink-0">
                <img
                  src={LOGO_WITH_NAME}
                  alt="Dr. Mateus Marques"
                  className="w-full h-full object-cover" />

              </div>
              <div>
                <div className="font-poppins font-bold text-white text-base leading-tight">Dr. Mateus Marques</div>
                <div className="text-[#00897B] text-sm font-semibold">Cirurgião Torácico</div>
              </div>
            </div>
            <p className="text-white/55 text-sm leading-relaxed max-w-sm">
              Especialista em Simpatectomia Torácica para tratamento definitivo de hiperidrose.
              Atendendo em Feira de Santana, BA.
            </p>
            <div className="mt-4 flex gap-3">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="bg-[#25D366] text-white text-xs font-semibold px-4 py-2 rounded-full hover:bg-[#1da851] transition-colors">

                WhatsApp
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Instagram"
                className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#E1306C] hover:text-white transition-all duration-200">

                <Instagram size={15} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-poppins font-semibold text-white mb-4 text-sm">Navegação</h4>
            <ul className="space-y-2">
              {navLinks.map((link) =>
              <li key={link.href}>
                  <a
                  href={link.href}
                  className="text-white/55 hover:text-[#00897B] text-sm transition-colors">

                    {link.label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-poppins font-semibold text-white mb-4 text-sm">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin size={14} className="text-[#00897B] mt-0.5 flex-shrink-0" />
                <span className="text-white/55 text-xs leading-relaxed">
                  Feira de Santana, BA<br />
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={14} className="text-[#00897B] flex-shrink-0" />
                <a
                  href="tel:+5575981872440"
                  data-testid="footer-phone-link"
                  className="text-white/55 hover:text-white text-xs transition-colors">

                  (75) 98187-2440
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} className="text-[#00897B] flex-shrink-0" />
                <a
                  href="mailto:contato@drmateusmmarques.com.br"
                  data-testid="footer-email-link"
                  className="text-white/55 hover:text-white text-xs transition-colors">mateus.cirtorax@gmail.com


                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/35 text-xs text-center md:text-left">© 2026 Dr. Mateus Marques. CRM-BA 28.632 / RQE 19.432. Todos os direitos reservados.

          </p>
          <div className="flex gap-6">
            {["", "", ""].map((link) =>
            <a
              key={link}
              href="#"
              className="text-white/35 hover:text-white/70 text-xs transition-colors">

                {link}
              </a>
            )}
          </div>
        </div>

        <p className="text-white/20 text-xs text-center mt-6 leading-relaxed max-w-3xl mx-auto">
          As informações contidas neste site são de caráter educativo e informativo.
          Não substituem consulta médica. Resultados individuais podem variar.
          Procure um profissional de saúde qualificado para avaliação e indicação terapêutica.
        </p>

      </div>
    </footer>);

}